/// <reference path="../../ng-services/chat.service.ts"/>

import { Attachment, ChatConversationMessage } from '../../models/chat';
import { LightboxService } from '../../ng-services/lightbox.service';

(function () {
    class ChatMessageAttachmentComponent {
        static $inject = ['LightboxService'];

        public attachment!: Attachment;
        public attachments!: Attachment[];
        public message!: ChatConversationMessage;

        constructor(private lightboxService: LightboxService) {}

        get downloadUrl() {
            return this.attachment?.urls?.download_url;
        }

        get thumbnailUrl() {
            return this.attachment?.urls?.thumb_url;
        }

        get isSupported() {
            return this.lightboxService.isSupported(this.attachment.file_mimetype as string);
        }

        handleClick() {
            if (this.isSupported) {
                const mapToLightboxItem = (attachment: any) => ({
                    owner: this.message.owner,
                    ...attachment,
                    ...attachment.urls,
                    id: attachment.hash,
                });

                return this.lightboxService.openGallery(
                    this.attachments.map((a) => mapToLightboxItem(a)),
                    mapToLightboxItem(this.attachment)
                );
            }

            this.download();
        }

        get icon() {
            return this.lightboxService.getIcon(this.attachment.file_mimetype as string);
        }

        private download() {
            window.open(this.downloadUrl, '_blank');
        }
    }

    angular.module('tradersyard').component('tyChatMessageAttachment', {
        // language=HTML
        template: `
        <div class="chat_message_attachment" ng-click="$ctrl.handleClick()">
            <div class="chat_message_attachment__thumbnail">
                <img ng-src="{{$ctrl.icon}}" alt="icon" ng-if="!$ctrl.isImage">
                <img ng-src="{{$ctrl.thumbnailUrl}}" alt="{{$ctrl.attachment.name}}" ng-if="$ctrl.isImage">
            </div>
            <div class="chat_message_attachment__name">
                {{$ctrl.attachment.name}}
            </div>
        </div>
    `,
        bindings: {
            attachment: '<',
            attachments: '<',
            message: '<',
        },
        controller: ChatMessageAttachmentComponent,
    });
})();
